import React, { Component } from "react";

import {
    Layout, Menu
} from 'antd';

import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";

import Statements from './Statements';
import Drivers from './Drivers';
import Sales from './Sales';
import Attendance from './Attendance';
import Transactions from './Transactions';
import Moves from './Moves';

const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;

class Reports extends Component {

    constructor(props) {
        super(props);

        const url = props.location.pathname.split('/');

        this.state = {
            selectedTab: url[url.length-1]//url.length > 3 ? url[url.length-1] : 'jobs'
        }
    }

    render() {
        return (
            <>
                <Layout style={{ padding: '24px 0', background: '#fff' }}>

                    <HashRouter>
                        <Sider width={200} style={{ background: '#fff'}}>
                            <Menu
                                mode="inline"
                                defaultSelectedKeys={this.state.selectedTab}
                                style={{ height: '100%' }}
                            >
                                {localStorage.isDispatch == 1 || localStorage.type == 'crm' ? (
                                    <Menu.Item key="statements"><NavLink to={`/reports/statements`}>Statements</NavLink></Menu.Item>
                                ) : null}
                                {localStorage.isDispatch == 1 ? (
                                    <Menu.Item key="drivers"><NavLink to={`/reports/drivers`}>Timesheets</NavLink></Menu.Item>
                                ) : (
                                    <Menu.Item key="attendances" className={localStorage.type == 'crm' ? 'hide' : ''}><NavLink to={`/reports/attendances`}>Attendances</NavLink></Menu.Item>
                                )}
                                <Menu.Item key="sales"><NavLink to={`/reports/sales`}>Sales</NavLink></Menu.Item>
                                <Menu.Item key="transactions"><NavLink to={`/reports/transactions`}>Transactions</NavLink></Menu.Item>
                                {localStorage.isDispatch == 1 ? (
                                    <Menu.Item key="moves"><NavLink to={`/reports/moves`}>Moves</NavLink></Menu.Item>
                                ) : null}
                            </Menu> 
                        </Sider>
                    </HashRouter>

                    <Content style={{ padding: '0 24px' }}>
                        <Route exact path={`/reports/statements`} component={Statements} />
                        <Route exact path={`/reports/drivers`} component={Drivers} />
                        <Route exact path={`/reports/sales`} component={Sales} />
                        <Route exact path={`/reports/attendances`} component={Attendance} />
                        <Route exact path={`/reports/transactions`} component={Transactions} />
                        <Route exact path={`/reports/moves`} component={Moves} />
                    </Content>

                </Layout>
            </>
        )
    }
}

export default Reports;